<template>
  
  <div class="side-con">
<div class="flex-shrink-0 p-3 bg-white nav-right p-0" style="width: 280px;">
  <div class="img_con pb-3 mb-3 logo">
     <img src="../assets/logoo.png" alt="" style="width:5rem">
     <p >العتيقه تيكنولوجي</p>

    </div>
       
    <ul class="list-unstyled ps-0 text-right bac">
      <div class="fleex  btn-toggle  rounded collapsed " data-bs-toggle="collapse" data-bs-target="#home-collapse" aria-expanded="true">
        <h5 class="arrow">&lt;</h5>
        <button class="btn btn-toggle align-items-center rounded collapsed white font-s" >
          البلدان والمدن
           <img src="../assets/place.png" alt="" class="icon">
        </button></div>
      <li class="mb-1">
        
        <div class="collapse " id="home-collapse">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small mr-3">
                            
                             <li  class="li-nav border0"> <router-link to="/ViewGov" class=" rounded font-s white" >المحافظات</router-link>  
                                       <img src="../assets/gov.png" alt="" class="icon">
   </li>
                             <li  class="li-nav border0"> <router-link to="/ViewDirectorates" class=" rounded font-s white" >المديريات</router-link>  
                                       <img src="../assets/mid.png" alt="" class="icon">
   </li>
                             <li  class="li-nav border0"> <router-link to="/CityView" class=" rounded font-s white" >المدن</router-link>  
                                       <img src="../assets/city.png" alt="" class="icon">
   </li>
    <li  class="li-nav border0"> <router-link to="/districtView" class=" rounded font-s white" >الحي</router-link>  
                                       <img src="../assets/square.png" alt="" class="icon">
   </li>
                             <li  class="li-nav border0"> <router-link to="/ViewRes" class=" rounded font-s white" >المربع السكني</router-link>  
                                       <img src="../assets/square.png" alt="" class="icon">
   </li>
                             

          </ul>
        </div>
      </li>
      <li class="mb-1">
         <div class="fleex  btn-toggle  rounded collapsed " data-bs-toggle="collapse" data-bs-target="#dashboard-collapse" aria-expanded="true">
        <h5 class="arrow">&lt;</h5>
        <button class="btn btn-toggle align-items-center rounded collapsed white font-s" data-bs-toggle="collapse" data-bs-target="#dashboard-collapse" aria-expanded="false">
          التحقيقات
                    <img src="../assets/detective.png" alt="" class="icon">
        </button></div>
        <div class="collapse" id="dashboard-collapse">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small  mr-3">
             
                 <li  class="li-nav border0"> <router-link to="/RecordView" class=" rounded white font-s" >المحاضر </router-link> 
                                     <img src="../assets/report(1).png" alt="" class="icon">
                    </li>
                 <li  class="li-nav border0"> <router-link to="/DetictiveView" class=" rounded white font-s" >المحققون </router-link> 
                                     <img src="../assets/detective.png" alt="" class="icon">
                    </li>
         

           
          </ul>
        </div>
      </li>
      
       <li class="mb-1">
         <div class="fleex  btn-toggle  rounded collapsed " data-bs-toggle="collapse" data-bs-target="#Complain-collapse" aria-expanded="true">
        <h5 class="arrow">&lt;</h5>
        <button class="btn btn-toggle align-items-center rounded collapsed white font-s" data-bs-toggle="collapse" data-bs-target="#Complain-collapse" aria-expanded="false">
          الشكوى
                    <img src="../assets/report.png" alt="" class="icon">
        </button></div>
        <div class="collapse" id="Complain-collapse">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small  mr-3">
              
                 <li  class="li-nav border0"> <router-link to="/ComplainView" class=" rounded white font-s" >الشكاوي </router-link> 
                                     <img src="../assets/report.png" alt="" class="icon">
                    </li>
                 
                
        

           
          </ul>
        </div>
      </li>

       <li class="mb-1">
         <div class="fleex  btn-toggle  rounded collapsed " data-bs-toggle="collapse" data-bs-target="#adding-collapse" aria-expanded="true">
        <h5 class="arrow">&lt;</h5>
        <button class="btn btn-toggle align-items-center rounded collapsed white font-s" data-bs-toggle="collapse" data-bs-target="#adding-collapse" aria-expanded="false">
          تهيئة النظام
                    <img src="../assets/report(1).png" alt="" class="icon">
        </button></div>
        <div class="collapse" id="adding-collapse">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small  mr-3">
              
                 <li  class="li-nav border0"> <router-link to="/NationalityView" class=" rounded white font-s" >الجنسيات </router-link> 
                                     <img src="../assets/citizenship.png" alt="" class="icon">
                    </li>

                 <li  class="li-nav border0"> <router-link to="/Marital_StatusView" class=" rounded white font-s" >الحالة الاجتماعية </router-link> 
                                     <img src="../assets/wedding.png" alt="" class="icon">
                    </li>
                 
                 <li  class="li-nav border0"> <router-link to="/Complaint_TypeView" class=" rounded white font-s" > نوع الشكوى </router-link> 
                                     <img src="../assets/report(1).png" alt="" class="icon">
                    </li>
                 
                 <li  class="li-nav border0"> <router-link to="/IdentityView" class=" rounded white font-s" >  الهوية </router-link> 
                                     <img src="../assets/citizenship.png" alt="" class="icon">
                    </li>
                 
                 <li  class="li-nav border0"> <router-link to="/Education_LevelView" class=" rounded white font-s" >  المستوى التعليمي </router-link> 
                                     <img src="../assets/college.png" alt="" class="icon">
                    </li>
                 
                 <li  class="li-nav border0"> <router-link to="/Status_TypeView" class=" rounded white font-s" >   الحالة </router-link> 
                                     <img src="../assets/citizenship.png" alt="" class="icon">
                    </li>
                 
                 <li  class="li-nav border0"> <router-link to="/Complaint_RecipientView" class=" rounded white font-s" >   الظروف </router-link> 
                                     <img src="../assets/report.png" alt="" class="icon">
                    </li>
                 
                 <li  class="li-nav border0"> <router-link to="/Complaint_ProceduresView" class=" rounded white font-s" >   الاجراءات </router-link> 
                                     <img src="../assets/report(1).png" alt="" class="icon">
                    </li>
                 
                
        

           
          </ul>
        </div>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
export default {
name:'sidenavhot'
}
</script>

<style>
.side-con{
    background: #235aae;
    height: 100%;
}
.bac{
    background: #235aae;
}
</style>